import React from 'react';
import {Box, Container, Image, Text} from "@chakra-ui/react";
import {Swiper, SwiperSlide} from "swiper/react";
import {EffectCoverflow, Scrollbar, Mousewheel,Navigation,Pagination,FreeMode} from "swiper";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import {galleryStaticData} from "../../helpers/adminData";
import Fancybox from "../Gallery/Fancybox"

const Gallery = () => {
    return (
        <Box name="gallery" w="full" mb="150px">
            <Container maxW="container.xl">
                <Text pb={{base: "28px", md: "30px"}} fontFamily='Raleway' fontWeight="700"
                      fontSize={{base: "24px", md: "40px"}} color="#111212" lineHeight={{base: "28px", md: "47px"}}>
                    Вакуумная заливка моделей <br/> <span style={{color: "#E92F34"}}>расплавленным металлом</span>
                </Text>
                <Box className="gallery" h="574px" borderLeft="3px solid #1B1918;" pl={{base: "20px", md: "60px"}}>
                    <Swiper
                        effect={"coverflow"}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}
                        grabCursor={true}
                        centeredSlides={true}
                        scrollbar={true}
                        freeMode={true}
                        mousewheel={true}
                        slidesPerView={3}
                        coverflowEffect={{
                            rotate: 50,
                            stretch: 0,
                            depth: 100,
                            modifier: 1,
                            slideShadows: true,
                        }}
                        modules={[EffectCoverflow, Scrollbar, Mousewheel,Navigation,Pagination,FreeMode]}
                        breakpoints={{
                            768: {
                                slidesPerView: 2
                            },
                            576: {
                                slidesPerView: 2
                            },
                            320: {
                                slidesPerView: 1
                            },
                        }}
                        className="mySwiper"
                    >
                        {galleryStaticData.map(({img}) => (
                            <SwiperSlide >
                                <Fancybox options={{Carousel: {infinite: true,}}}>
                                    <a data-fancybox="gallery" href={img}>
                                        <Box w="full" h="full">
                                            <Image w="100%" h="100%" borderRadius="20px" src={img} alt="img"/>
                                        </Box>
                                    </a></Fancybox>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Box>
            </Container>
        </Box>
    );
};

export default Gallery;